import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Panel, Heading } from '@printdeal/ui-library';
import { dynamicQuoteMessage } from '../../../../../helpers/segmentedCustomerHelper';

const QuoteSidePanel = () => {
  const steps = [
    {
      id: 'account.quotes.form.list.preferences',
      content: (
        <FormattedMessage
          id="account.quotes.form.list.preferences"
          defaultMessage="Submit your preferences in the form."
        />
      ),
    },
    {
      id: 'account.quotes.form.list.nonbinding.quote',
      content: (
        <>
          <FormattedMessage
            id="account.quotes.form.list.nonbinding.quote.prefix"
            defaultMessage="We will send you a"
          />{' '}
          <span className="pd-font-bold">
            <FormattedMessage
              id="account.quotes.form.list.nonbinding.quote.bold"
              values={{
                responseTime: dynamicQuoteMessage(),
              }}
              defaultMessage="non-binding quote within {responseTime} hours."
            />
          </span>
        </>
      ),
    },
    {
      id: 'account.quotes.form.list.place.order',
      content: (
        <FormattedMessage
          id="account.quotes.form.list.place.order"
          defaultMessage="After you approve, you can place the order for the product."
        />
      ),
    },
  ];

  return (
    <Panel>
      <Heading as="h3" className="pd-mb-2">
        <FormattedMessage
          id="account.quotes.form.heading.quoteProcess"
          defaultMessage="Here is how requesting a quote works:"
        />
      </Heading>
      <ol className="pd-flex pd-list-decimal pd-flex-col pd-gap-2 pd-pl-5 pd-text-sm">
        {steps.map((step) => (
          <li key={step.id}>{step.content}</li>
        ))}
      </ol>
    </Panel>
  );
};

export default QuoteSidePanel;
